"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DentalMonitoringPatientResponse_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var DentalMonitoringPatientLinks_1 = require("./DentalMonitoringPatientLinks");
var DentalMonitoringMonitoring_1 = require("./DentalMonitoringMonitoring");
var DentalMonitoringPatientResponse_Factory = /** @class */ (function () {
    function DentalMonitoringPatientResponse_Factory() {
    }
    DentalMonitoringPatientResponse_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            _links: DentalMonitoringPatientLinks_1.DentalMonitoringPatientLinks_Factory.CreateIncoming(model._links),
            creation_date: model.creation_date,
            current_aligner_index: model.current_aligner_index,
            date_of_birth: model.date_of_birth,
            email: model.email,
            external_id: model.external_id,
            firstname: model.firstname,
            force_next_aligner_change: model.force_next_aligner_change,
            fullname: model.fullname,
            is_app_activated: model.is_app_activated,
            lastname: model.lastname,
            locale: model.locale,
            medical_file_number: model.medical_file_number,
            monitoring: DentalMonitoringMonitoring_1.DentalMonitoringMonitoring_Factory.CreateIncoming(model.monitoring),
            notes: model.notes,
            num_guardians: model.num_guardians,
            patient_id: model.patient_id,
            phone: model.phone,
            profile_id: model.profile_id,
            push_notifications_hour: model.push_notifications_hour,
            scan_process_version: model.scan_process_version,
            total_aligner_index: model.total_aligner_index,
        };
        return result;
    };
    DentalMonitoringPatientResponse_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            _links: DentalMonitoringPatientLinks_1.DentalMonitoringPatientLinks_Factory.CreateOutgoing(model._links),
            creation_date: model.creation_date,
            current_aligner_index: model.current_aligner_index,
            date_of_birth: model.date_of_birth,
            email: model.email,
            external_id: model.external_id,
            firstname: model.firstname,
            force_next_aligner_change: model.force_next_aligner_change,
            fullname: model.fullname,
            is_app_activated: model.is_app_activated,
            lastname: model.lastname,
            locale: model.locale,
            medical_file_number: model.medical_file_number,
            monitoring: DentalMonitoringMonitoring_1.DentalMonitoringMonitoring_Factory.CreateOutgoing(model.monitoring),
            notes: model.notes,
            num_guardians: model.num_guardians,
            patient_id: model.patient_id,
            phone: model.phone,
            profile_id: model.profile_id,
            push_notifications_hour: model.push_notifications_hour,
            scan_process_version: model.scan_process_version,
            total_aligner_index: model.total_aligner_index,
        };
        return result;
    };
    return DentalMonitoringPatientResponse_Factory;
}());
exports.DentalMonitoringPatientResponse_Factory = DentalMonitoringPatientResponse_Factory;
